import { createAsyncThunk } from '@reduxjs/toolkit';
import { EndPoints, StaticBody } from '../../../common/enums/enums';
import { amplifyApi } from '../../../hooks/amplifyApi';
import { orderActionTypes } from '../../types';

export const getMyOrders = createAsyncThunk(
  orderActionTypes.getMyOrders,
  async ({ personId, companyId, pageNumber, searchQuery }) => {
    return await amplifyApi(
      {
        ...StaticBody.orders.myOrders,
        pageNumber,
        searchQuery,
        filters: [
          { column: 'ownerId', value: personId, operator: 'eq' },
          { column: 'companyId', value: companyId, operator: 'eq' },
        ],
      },
      EndPoints.ORDERS.UNAPPROVED.GET_ORDERS.ENDPOINT,
      EndPoints.ORDERS.UNAPPROVED.GET_ORDERS.METHOD
    );
  }
);
